import { useNavigate, useOutletContext } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import type LegalEntity from 'modules/core/store/models/LegalEntity'

import CreateEmployeeGroupModal from 'modules/legal_entities/components/EmployeeGroups/CreateModal'

const CreateEmployeeGroupModalPage = () => {
  const { navigation } = useNavigation()

  const { legalEntity } = useOutletContext<{ legalEntity: LegalEntity }>()
  const navigate = useNavigate()

  const onClose = () => {
    navigate(navigation.settings.legalEntitiesId.employeeGroups.fullPath({ id: legalEntity.id }))
  }

  return <CreateEmployeeGroupModal onClose={onClose} legalEntity={legalEntity} />
}

export default CreateEmployeeGroupModalPage
